import { useCallback, useEffect, useMemo, useState } from 'react';

import { useSafeAreaInsets } from 'react-native-safe-area-context';

import debounce from 'lodash.debounce';

export default function useDebouncedSafeAreaInsets() {
    const safeAreaInsets = useSafeAreaInsets();

    const [insets, setInsets] = useState(safeAreaInsets);

    const updateStateDebounced = useCallback(debounce(setInsets, 100), []);

    useEffect(() => {
        updateStateDebounced(safeAreaInsets);

        return () => {
            updateStateDebounced.cancel();
        };
    }, [safeAreaInsets]);

    return useMemo(
        () => ({
            left: insets.left,
            top: insets.top,
            right: insets.right,
            bottom: insets.bottom,
        }),
        [insets],
    );
}
